import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sound-off.tsx
/**
* icon.24.sound.off
*
* Keywords: megaphone, muted, speaker, audio, disabled, silence, crossed-out, diagonal-line
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyLjE0NyAxMS45NzVhLjUuNSAwIDAgMSAuODUzLjM1M1YxOGExIDEgMCAwIDEtMS43MDcuNzA3bC0yLjcwNC0yLjcwNEw4LjU4MiAxNmEuMTkuMTkgMCAwIDEtLjEzNS0uMzI1bC4zMzgtLjMzOWEuMzkuMzkgMCAwIDEgLjU1IDBsMi42NDggMi42NDdjLjAwNy4wMDYuMDE3LjAwMS4wMTctLjAwN3YtNS42NDdhLjUuNSAwIDAgMSAuMTQ2LS4zNTNtMy01LjgyOWEuNS41IDAgMSAxIC43MDcuNzA4bC0xMSAxMWEuNS41IDAgMCAxLS43MDgtLjcwN3ptLTMuODU0LS44NTRBMSAxIDAgMCAxIDEzIDUuOTk5di42NzNhLjUuNSAwIDAgMS0xIDB2LS42NDljMC0uMDA4LS4wMS0uMDEzLS4wMTctLjAwN2wtMi45OCAyLjk4TDguOTk2IDlINi41YS41LjUgMCAwIDAtLjUuNXY0LjE3M2EuNS41IDAgMCAxLS4xNDYuMzUzbC0uNTczLjU3MmMtLjEwNS4xMDUtLjI4MS4wNTEtLjI4MS0uMDk4di01QTEuNSAxLjUgMCAwIDEgNi41IDhoMi4wODJsLjAwNy0uMDAzeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1850
*/
const Icon24SoundOff = memo(function Icon24SoundOff(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12.147 11.975a.5.5 0 0 1 .853.353V18a1 1 0 0 1-1.707.707l-2.704-2.704L8.582 16a.19.19 0 0 1-.135-.325l.338-.339a.39.39 0 0 1 .55 0l2.648 2.647c.007.006.017.001.017-.007v-5.647a.5.5 0 0 1 .146-.353m3-5.829a.5.5 0 1 1 .707.708l-11 11a.5.5 0 0 1-.708-.707zm-3.854-.854A1 1 0 0 1 13 5.999v.673a.5.5 0 0 1-1 0v-.649c0-.008-.01-.013-.017-.007l-2.98 2.98L8.996 9H6.5a.5.5 0 0 0-.5.5v4.173a.5.5 0 0 1-.146.353l-.573.572c-.105.105-.281.051-.281-.098v-5A1.5 1.5 0 0 1 6.5 8h2.082l.007-.003z"
		})
	});
});
//#endregion
export { Icon24SoundOff };

//# sourceMappingURL=icon-24-sound-off.js.map